<div [formGroup]="configFormGroup">
  <h2>File Control Config</h2>
  <div dwRow>
    <div dwCol="6">
      <label>Attachment Id</label>
      <select formControlName="attachmentId" class="form-control">
        <option *ngFor="let attr of itemMetaData?.Attributes" [ngValue]="attr.AttributeName">
          {{ attr.Display }}
        </option>
      </select>
    </div>
  </div>
</div>
